
import React from "react";
import { i18nManager } from "../../i18n";
import { Schemes, Utils } from "../../utils";
import LoadingGif from "../../assets/images/loading_circle.gif";
import { RegisterForTournament } from "../sections/tournaments/RegisterForTournament";
import { Button, Classname, DateHelper, Dropdown, NoseurObject } from "@rivtn/noseur";
import { ApiResponseData, BaseService, IMember, ITournamentEditionRegistered, ITournamentEdition, SanitizedResponse, TournamentService } from "../../services";

export interface TournamentFeedProps {

    profile: IMember;

}

function TournamentFeed(props: TournamentFeedProps) {

    const tournamentService = TournamentService.getInstance();
    const labels = i18nManager.Labels.compound.landing.tournament_feed;
    const [query, setQuery] = React.useState<NoseurObject<any>>(Utils.getSetting("tfq", { status__in: ["UPCOMING", "ONGOING", "ENDED"] }));
    const [tournamentEditions, setTournamentEditions] = React.useState<ApiResponseData<ITournamentEdition>>({});

    React.useEffect(() => {
        fetchTournaments();
        Utils.updateSettings("omnehost.tf", query);
    }, [query]);

    return (<div className="tournament-feed">
        <div className="control">
            <div className="params">
                <div className="pills">
                    <span className={Classname.build("noseur-pill", { "active": query.status__in.includes("UPCOMING") })} onClick={() => toggleStatus("UPCOMING")}>{labels.controls.upcoming}</span>
                    <span className={Classname.build("noseur-pill", { "active": query.status__in.includes("ONGOING") })} onClick={() => toggleStatus("ONGOING")}>{labels.controls.ongoing}</span>
                    <span className={Classname.build("noseur-pill", { "active": query.status__in.includes("ENDED") })} onClick={() => toggleStatus("ENDED")}>{labels.controls.ended}</span>
                </div>
                <i className="fa fa-times omnehost-tx" onClick={() => setQuery({ status__in: [] })} />
            </div>
            <Dropdown fill scheme={Schemes.OMNEHOST} />
        </div>
        <div className="tf-tournaments">
            {!tournamentEditions.content && (<div style={{ margin: "auto", display: "flex", marginTop: 150 }}>
                <img alt={"loading tournament hosts"} src={LoadingGif} style={{ width: 50, margin: "auto" }} />
            </div>)}
            {tournamentEditions.content?.map((tournamentEdition) => {
                const tournamentEnded = DateHelper.isPast(new Date(tournamentEdition.dates.tournament_end_date ?? ""));
                const tournamentUpcoming = DateHelper.isFuture(new Date(tournamentEdition.dates.tournament_start_date ?? ""));
                const hasPrize = tournamentEdition.meta?.price_pool_monetary || tournamentEdition.meta?.price_pool_physical;
                const tournamentOngoing = DateHelper.isPast(new Date(tournamentEdition.dates.tournament_start_date ?? "")) && DateHelper.isFuture(new Date(tournamentEdition.dates.tournament_end_date ?? ""));
                const tournamentRegistrationOpen = DateHelper.isPast(new Date(tournamentEdition.dates.registration_start_date ?? "")) && DateHelper.isFuture(new Date(tournamentEdition.dates.registration_end_date ?? ""));

                return (<div className="tf-tournament" key={tournamentEdition.external_id}>
                    <div className="information">
                        <div className="media">
                            <img alt={tournamentEdition.name} src={tournamentEdition?.logo_url} />
                            {hasPrize && (<i className="fa fa-trophy" />)}
                        </div>
                        <div className="infos">
                            <div className="title">
                                <span className="l lined-limit">{tournamentEdition.name}</span>
                                <span className={Classname.build("noseur-pill", { "tf-pill-ended": tournamentEnded, "tf-pill-ongoing": tournamentOngoing, "tf-pill-upcoming": tournamentUpcoming })} style={{ marginLeft: 6 }}>
                                    {tournamentEnded && (labels.controls.ended)}
                                    {tournamentOngoing && (labels.controls.ongoing)}
                                    {tournamentUpcoming && (labels.controls.upcoming)}
                                </span>
                            </div>
                            <span className="lined-limit">{Utils.formatToFineDate2(tournamentEdition.dates.tournament_start_date ?? "")}</span>
                            <span className="lined-limit">{tournamentEdition.program?.name}</span>
                            <span className="lined-limit">{i18nManager.Labels.teams.team_type_presentable[tournamentEdition.team_type.toLowerCase()]}</span>
                            <span className="lined-limit">{labels.by} <b>{tournamentEdition.tournament?.host?.name}</b></span>
                        </div>
                    </div>
                    <div className="control">
                        {tournamentEnded
                            ? (<Button raised linkTarget="_blank" link={Utils.buildPublicUrl("TOURNAMENT", tournamentEdition.tournament.public_id, "?p=result")} text={labels.view_result} scheme={Schemes.OMNEHOST} />)
                            : (<>
                                <Button raised text={labels.register} disabled={!tournamentRegistrationOpen} scheme={Schemes.OMNEHOST} style={{ marginRight: 5 }} onClick={() => RegisterForTournament(props.profile, { tournament_edition: tournamentEdition } as ITournamentEditionRegistered)} />
                                <Button raised linkTarget="_blank" link={Utils.buildPublicUrl("TOURNAMENT", tournamentEdition.tournament.public_id)} text={labels.view_detail} scheme={Schemes.OMNEHOST} style={{ marginLeft: 5 }} />
                            </>)}
                    </div>
                </div>);
            })}
        </div>
    </div>);

    function toggleStatus(status: string) {
        const statuses = query.status__in;
        const statusIndex = statuses.indexOf(status);
        if (statusIndex > -1) statuses.splice(statusIndex, 1);
        else statuses.push(status);
        setQuery({
            ...query,
            status__in: statuses
        });
    }

    function fetchTournaments() {
        setTournamentEditions({});
        tournamentService.queryTournamentEditions({ ...query, __member_id__: props.profile.external_id, }).then(({ apiResponse }: SanitizedResponse<ITournamentEdition>) => {
            setTournamentEditions(apiResponse.data!);
        }).catch(BaseService.reportError);
    }

}

export default TournamentFeed;
